$(document).ready(function(){
  // 	 var urlHash = window.location.href.split("#")[1];
  //   	 console.log(urlHash);
  //   if(urlHash != "" || urlHash != "undefined" ) {
  //   	jQuery('html,body').animate({
  //         scrollTop: jQuery('#' + urlHash).offset().top - 100
  //     }, 200); }
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

});


//slick slider code//

$().ready(function(){
  $('.slick-carousel').slick({
    arrows: true,
    centerPadding: "0px",
    dots: true,
    slidesToShow: 1,
    infinite: false
  });
});


$('.testimonals-review').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.img-sec'
});
$('.img-sec').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.testimonals-review',
  dots: true,
  centerMode: true,
  focusOnSelect: true,
  infinite: true
});
//scroll down arrow//

jQuery(document).ready(function () {
  /*jQuery(".down").on("click", function () {
    $('html, body').animate({scrollTop: '+=750px'}, 800);
  });
  /*$('body .sidebar-tabing-listing a.down').on('click', function() {
      var pattern = /scroll-effect-section-([0-9]+)/;
      var parentClass = $(this).parent('.sidebar-tabing-listing').parent('div').find('.homepage-section').attr('class').split(/\s+/);
      $.each(parentClass, function(index, item) {
          if (pattern.test(item)) {
              var className = item;
              var indexOflastHash = item.lastIndexOf('-') + 1;
              var strOut = parseInt(item.substr(indexOflastHash))+1;
              console.log(strOut);
            if(strOut > 5) {
              $('html, body').animate({
         scrollTop: $('.site-footer').offset().top
     }, 200);
            } else {

              $('html, body').animate({
         scrollTop: $('.scroll-effect-section-'+strOut).offset().top
     }, 200);
            }

              return false;
          }
      });
  });*/
});

//add class active on side bar tabing //

$(document).ready(function(){
  var counter_sec = 1;
  $('body .main-content .shopify-section').each(function() {
    $(this).attr('data-anchor', 'section-scroll-'+counter_sec);
    counter_sec = counter_sec + 1;
  });
  $('body .anchors ul li a').on('click', function() {
    $('body .anchors ul li').removeClass('active');
    $(this).parent('li').addClass('active');
  });
  $('body .sidebar-tabing-listing .anchors a.down').on('click', function() {
    var pattern = /#section-scroll-([0-9]+)/;
    var tab_active = $('body .anchors ul li.active a').attr('href');
    console.log(tab_active);
    if (pattern.test(tab_active)) {
      console.log('in active');
      var indexOflastHash = tab_active.lastIndexOf('-') + 1;
      var strOut = parseInt(tab_active.substr(indexOflastHash))+1;
      console.log(strOut);
      if(strOut > 5) {
        $('body .anchors ul li').removeClass('active');
        $('body .main-content .shopify-section').removeClass('pg-active');
        $('body .main-content .shopify-section[data-anchor="section-scroll-6"]').addClass('pg-active');
        window.location.href = "https://leafy-plants.myshopify.com/#section-scroll-6";
      } else {
        $('body .anchors ul li a[href="#section-scroll-'+strOut+'"]').trigger("click");
        $('body .main-content .shopify-section').removeClass('pg-active');
        $('body .main-content .shopify-section[data-anchor="section-scroll-'+strOut+'"]').addClass('pg-active');
        window.location.href = "https://leafy-plants.myshopify.com/#section-scroll-"+strOut;
      }
    }
  });
  setInterval(function() {
    $('body .main-content .shopify-section').each(function() {
      if($(this).hasClass('pg-active')) {
        $('body .anchors ul li').removeClass('active');
        var tab_active = $(this).attr('data-anchor');
        $('body .anchors ul li a[href="#'+tab_active+'"]').parent('li').addClass('active');

        /* add active class on header and body*/

        var active_body = $('body .anchors ul li a[href="#'+tab_active+'"]').text();
        if(active_body =="01")
        {
          $('body').removeClass(' added02 added03 added04 added05');
          $('body').addClass('added'+active_body);
          $('header').removeClass(' header02 header03 header04 header05');
          $('header').addClass('header'+active_body);

        } else if(active_body =="02"){
          $('body').removeClass('added01  added03 added04 added05');
          $('body').addClass('added'+active_body);
          $('header').removeClass('header01  header03 header04 header05');
          $('header').addClass('header'+active_body);
        }
        else if(active_body =="03"){
          $('body').removeClass('added01  added02 added04 added05');
          $('body').addClass('added'+active_body);
          $('header').removeClass('header01  header02 header04 header05');
          $('header').addClass('header'+active_body);
        }
        else if(active_body =="04"){
          $('body').removeClass('added01  added02 added03 added05');
          $('body').addClass('added'+active_body);
          $('header').removeClass('header01  header02 header03 header05');
          $('header').addClass('header'+active_body);
        }
        else if(active_body =="05"){
          $('body').removeClass('added01  added02 added03 added04');
          $('body').addClass('added'+active_body);
          $('header').removeClass('header01  header02 header03 header05');
          $('header').addClass('header'+active_body);
        }
        else
        {
          $('body').removeClass('added01 added02 added03 added04 added05');
        }
        return false;
      }
    });
  },500);


  /* sticky header*/   
  var counter = 1;
  $('body').each(function() {
    $(this).addClass('active-'+counter);
    counter_sec = counter + 1;
  });
  $('body').on('scroll', function() {
    $('body').removeClass('active'+counter_sec);
    $(this).parent('body').addClass('active'+counter_sec);
    counter_sec = counter + 1;
  });   

});




/*$(document).scroll(function() {
    console.log('scrolled');
     var location_href = window.location.href;
     var last_index_of = location_href.lastIndexOf('/') + 1;
     var tab_active = location_href.substring(last_index_of);
     console.log(location_href);
     console.log(last_index_of);
     console.log(tab_active);
       if($('body .anchors ul li a[href="'+tab_active+'"]').length) {
         $('body .anchors ul li').removeClass('active');
       $('body .anchors ul li a[href="'+tab_active+'"]').parent('li').addClass('active');
     }

   }); 

// add code for fullpage slider//

// new fullpage('#MainContent', {
//     navigation: true,
//     responsiveWidth: 700,
//     anchors: ['home', 'about-us', 'contact', 'news', 'blogs'],
//     parallax: true,
//     onLeave: function(origin, destination, direction){
//         console.log("Leaving section" + origin.index);
//     },
// });

/* add active class into sidebar */


/*var s = $(".anchors ul li");
	var pos = s.position();					   
	$(window).scroll(function() {
		var windowpos = $(window).scrollTop();

      if(pos) {
		if (windowpos >= pos.top & windowpos <=10000000) {
			s.addClass("active");
		} else {
			s.removeClass("active");	
		}
      }
	});*/



jQuery(document).on("click",".add-qty",function() {
  var value_qty = jQuery(this).parent().find('.form-control.qty').val();
  jQuery(this).parent().find('.form-control.qty').val((value_qty*1)+1);
});
jQuery(document).on("click",".minus-qty",function() {
  var value_qty = jQuery(this).parent().find('.form-control.qty').val();
  if(value_qty <= '1'){
    return false;
  } else {
    jQuery(this).parent().find('.form-control.qty').val((value_qty*1)-1);
  }
});  



/*********************************************  Custom Filter   ******************************************************************/
/**************   This function is used for hide and show checkboxes on display  *************************************************/
// $(".accordion_head").click(function () {
//         if ($('.accordion_body').is(':visible')) {
//             $(".accordion_body").slideUp(300);
//             $(".plusminus").text('+');
//         }
//         if ($(this).next(".accordion_body").is(':visible')) {
//             $(this).removeClass('show');
//             $(this).addClass('close');
//             $(this).next(".accordion_body").removeClass('show');
//             $(this).next(".accordion_body").addClass('close');
//             $(this).next(".accordion_body").slideUp(300);
//             $(this).children(".plusminus").text('+');
//         } else {
//             $(this).removeClass('close');
//             $(this).addClass('show');
//             $(this).next(".accordion_body").slideDown(300);
//             $(this).next(".accordion_body").removeClass('close');
//             $(this).next(".accordion_body").addClass('show');
//             $(this).children(".plusminus").text('-');
//         }
//     });
//     $('.accordion_head').trigger('click');
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

var pathname = window.location.pathname; // Returns path only (/path/example.html)
var url      = window.location.href;     // Returns full URL (https://example.com/path/example.html)
var origin   = window.location.origin;   // Returns base URL (https://example.com)

var url_array=window.location.pathname.split('/');
var URl="";
var collectionTitle=url_array[2];

function getUrlVars()
{
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for(var i = 0; i < hashes.length; i++)
  {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  console.log('url_array',vars);
  return vars;
}

// 	  URl={ { collection.url |json}};
//  console.log('url_array',url_array);


if(url_array.length>3)
  var tags=url_array[3].split('+');
else
  var tags=[];

var count=0;
/******************** This funtion is used for onclick event for checkbox value   *******/
function getcheckbox(btn){ 

  URl=origin+'/'+url_array[1]+'/'+collectionTitle;
  var newTag = [];           var temp = [];          var qry;

  if (jQuery(btn).prop("checked",true)) {
    var btn_val=jQuery(btn).val();
    if(jQuery.inArray(btn_val, tags ) == "-1")
    {

      if (btn_val) {
        if(tags[0]=='')
        {
          tags[0]=btn_val;
        }
        else
          tags.push(btn_val);
      }

      $.each( tags, function( key, value ) {
        if(key==0)
        {
          URl +='/' + value;

        }
        else{
          URl +='+' + value;

        }
        count++;
      });


    }
    else
    {		
      var val= btn_val;
      URl = RemoveUrl(val); 


    }

    window.location.href = URl;          
    //      if (newTag.length) {
    // 	   window.location.href = jQuery('{{ 'tag' | link_to_add_tag: 'tag' }}').attr('href').replace('tag',jQuery(this).val());
    //     }
  }

}

/*********************************************  Remove value on Url  **********************************************/
function RemoveUrl(val)
{
  // arr is current radio button like Size or maintenace or sunlight array 
  tags = $.grep(tags, function(value){
    return value != val;
  });

  $.each( tags, function( key, value ) {
    if(key==0)
    {
      URl +='/'+value;
    }
    else{
      URl +='+'+value;
    }
  });
  return URl;
}


/******************************************** This Function is used for Get Radio button on onclick event **************************************************/       

function radio_btn(btn){

  URl=origin+'/'+url_array[1]+'/'+collectionTitle;

  var newTag = [];           var flag=false;
  var arr=[];           		
  var name_id=$(btn).attr('name');
  var btn_val= btn_id=$(btn).attr('value');

  switch(name_id) {			 /* This switch case function is used for check name id of radio button and get array for this radio button options   */  
    case "size":
      var size = ["size-small","size-medium","size-large"]; 
      arr=size;
      //            console.log('arr : ',arr);
      break;
    case "maintenace":
      var maintenace = ["maintenance-low","maintenance-medium","maintenance-high"];
      arr=maintenace;
      //              console.log('arr : ',arr);
      break;
    case "sunlight":
      var sunlight = ["sunlight-low","sunlight-medium","sunlight-high"];
      arr=sunlight;
      //         console.log('arr : ',arr);
      break;
  }

  if($('input[id="#'+btn_id+'"]').prop("checked", true))
  {   

    if(jQuery.inArray(btn_val, tags ) == "-1")
    {
      if(tags!=null){
        $.each(arr, function(key, val ){         		/* arr is current radio button like Size or maintenace or sunlight array */
          tags = $.grep(tags, function(value){		/* remove last value of current radio button if entered */ 
            return value != val;
          });
        });
      }  


      if (btn_val) {								/* Push current value into tags array for url */
        if(tags[0]=='')
        {
          tags[0]=btn_val;
        }
        else
          tags.push(btn_val);
      }

      //   console.log('arr : ',arr,'tags ',tags,' btn-val : ',btn_val);
      $.each( tags, function( key, value ) {				/***** Concatination of tags value into URl string   *****/

        if(key==0)
        {
          URl +='/'+value;

        }
        else{
          URl +='+'+value;

        }

      });
      var origional_URL = window.location.href;
      var query_string = getUrlVars();
      var count_param = 0;

      if(origional_URL == query_string[0]) {
        window.location.href = URl; 					/* launch current Url  */
      } else {
        $.each(query_string, function( index, value ) {
          if(++count_param == 1) {
            URl = URl + '?' + value + '=' + query_string[value];
          } else {
            URl = URl + '&' + value + '=' + query_string[value];
          }
        });
        window.location.href = URl;
      }

    }
    //         else      //if button is allready selected and this code is used to remove select option
    //         {

    //           var val= jQuery(this).val();
    //      			 tags = $.grep(tags, function(value){
    //   					return value != val;
    // 				});
    //           console.log('tags : ',tags);
    //         }
  }
}

$(document).ready(function() {
  //   var scroll_effect = setInterval(function() {
  //     var page_url = window.location.href;
  //     if(page_url.indexOf('about-us#') !== -1) {
  //       var id_pos = page_url.indexOf('#');
  //       var id = page_url.substring(id_pos); 
  //       $('html, body').stop().animate({
  //         'scrollTop': $('body '+id).offset().top - $('body header.site-header').outerHeight(true)
  //       }, 500, 'swing', function() {
  //         clearInterval(scroll_effect);
  //       });
  //     } else {
  //       clearInterval(scroll_effect);
  //     }
  //   }, 500);


  var scroll_effect = setInterval(function() {
    var page_url = window.location.href;
    if(page_url.indexOf('about-us#') !== -1) {
      var id_pos = page_url.indexOf('#');
      var id = page_url.substring(id_pos); 
      $('html, body').stop().animate({
        'scrollTop': $('body '+id).offset().top - $('body header.site-header').outerHeight(true)
      }, 500, 'swing', function() {

      });
      console.log('out');
      clearInterval(scroll_effect);
    } else {
      clearInterval(scroll_effect);
    }
  }, 500);
});